"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _TooltipTrigger = _interopRequireDefault(require("./TooltipTrigger"));
var Tooltip = function Tooltip(props) {
  var title = props.title,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
    children = props.children,
    _props$openDelay = props.openDelay,
    openDelay = _props$openDelay === void 0 ? 600 : _props$openDelay,
    _props$openDelayWhenH = props.openDelayWhenHasInstance,
    openDelayWhenHasInstance = _props$openDelayWhenH === void 0 ? 300 : _props$openDelayWhenH;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('tooltip');
  var classes = (0, _classnames.default)(prefixCls);
  return /*#__PURE__*/_react.default.createElement(_Popover.default, {
    trigger: [_TooltipTrigger.default, {
      delay: openDelay,
      openDelayWhenHasInstance: openDelayWhenHasInstance
    }],
    closeOnScroll: true,
    placement: placement,
    placementOffset: 20,
    overlay: function overlay() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__inner")
      }, title));
    },
    overlayStyle: {
      pointerEvents: 'none'
    },
    updateOnDimensionChange: false
  }, children);
};
var _default = exports.default = Tooltip;